import { ReactElement, useState } from 'react';
import { Button, Classes, Dialog } from '@blueprintjs/core';
import { UpdateAdmin } from '..';
import { Admin } from '@techshift/callie-private-api-typescript';

export type UpdateAdminButtonProps = {
	admin: Admin;
	onSuccess?: (admin: Admin) => void;
};
export function UpdateAdminButton(props: UpdateAdminButtonProps): ReactElement {
	const { admin, onSuccess } = props;

	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<Button
				icon={'edit'}
				onClick={() => {
					setIsOpen(true);
				}}
			>
				Edit
			</Button>
			<Dialog isOpen={isOpen}>
				<div className={Classes.DIALOG_BODY}>
					<UpdateAdmin
						admin={admin}
						onSuccess={(admin) => {
							onSuccess?.(admin);
							setIsOpen(false);
						}}
					/>
				</div>
				<div className={Classes.DIALOG_FOOTER}>
					<div className={Classes.DIALOG_FOOTER_ACTIONS}>
						<Button
							onClick={() => {
								setIsOpen(false);
							}}
						>
							Close
						</Button>
					</div>
				</div>
			</Dialog>
		</>
	);
}
